<template >
  <div id="builder" :ref="'top'">
    <div class="mainframe">
      <div class="menu-component collaps">
        <Menu v-bind:menu="menu"/>
      </div>
      <div :style="[{top: vertPosition}]" :class="{'extended': menuExtended}" class="collapsed-menu-component">
        <!-- <span @click="pxFromTop($refs.top)">{{this.pxFromTop($refs.top)}}</span> -->
        <MenuCollapsible :extended="getWidth() > 584 ? menuExtended : true" />
        
      </div>
      <div v-if="getWidth() < 584 && getCurrentPartType && getCurrentPartType !==''"  class="mobile-items-popup" :class="{'open': getCurrentPartType && getCurrentPartType !==''}">
        
        <MobileItems />
      </div>
      <div style="margin-top: 10px;" class="page-router-component">
        <PageRouter/>
      </div>
    </div>
  </div>
</template>

<script>
import Menu                 from './Menu.vue'
import MenuCollapsible      from './MunuCollapsible.vue'
import PageRouter           from './PageRouter.vue'
import {EventBus}           from '../../eventBus'
import MobileItems          from './MobileItems.vue'
import {mapGetters, mapActions} from 'vuex'

export default {
  name: 'Builder',
  components: {
    PageRouter,
    Menu,
    MenuCollapsible,
    MobileItems,
  },
  props: ["menu"],
  data(){
    return {
      vertPosition: '',
      menuExtended: false,
      posBoxA: 0,
    }
  },
  computed: {
    ...mapGetters([
      'getCurrentPartType'
    ])
  },
  methods: {
    ...mapActions([
      'setCurrentPartType'
    ]),
    // pxFromTop(el){
    //   console.log(this.calcPosOfBox())
    //   if(el){
    //     console.log('got element, ', el.getBoundingClientRect().x+'px')
    //     return el.getBoundingClientRect().x+'px'
    //   }
    //   return '0px'
    // },
    getWidth(){
        return window.innerWidth
    },
    calcPosOfBox() {
      const boxABB = this.$refs["top"].getBoundingClientRect();
      this.posBoxA = boxABB.x;

    }
  },
  mounted(){
    this.calcPosOfBox()
    EventBus.$on('extended', (bool) => {
      console.log('received extendMenu', bool)
      this.menuExtended = bool
    })
  },
}
</script>

<style>
.mobile-items-popup {
  height: 0px;

  position: absolute;
  z-index: 99999999;
  bottom: 0px;
    left: 0px;
    right: 0px;
    top: 66px;
    padding-left: 20px;
    padding-right: 15px;
  background-color: #191b20;
  overflow: scroll;
  overflow-x: hidden;
}
.mobile-items-popup.open {
  height: 100vh;
}
.bg-dark {
  background-color: #191b20 !important;
}
.navbar-dark {
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
.navbar-small {
  max-height: 45px;
}
.menu-component {
  display: inline-block;
  width: 26%;
  min-width: 309px;
  margin-top: 10px;
  padding-bottom: 15px;
}
.menu-title {
  display: inline-block;
}
.h4-indicator {
  display: inline-block;
  float: right;
}
.collapsed-menu-component {
  overflow: hidden;
  border: 1px solid #434857;
  width: 87px;
  max-height: 82vh;
  border-radius: 6px;
  position: absolute;
  display: none;
  background-color: #191b20;
  z-index: 9999;
  margin-top: 12px;
}
@media screen and (max-width: 1200px) {
  .collapsed-menu-component {
    padding-bottom: 5px;
    display: block;
    transition: 0.2s
    
  }
  .extended {
    width: 356px;
    min-width:350px;
    /* padding-right: 15px; */
    
  }
  .menu-component {
    display: none;
  }
  .collaps {
    transition: 0.2s;
    position: fixed;
    background-color: #191b20;
    z-index: 99999;
  }


  .page-router-component {
    width: 100% !important;
    margin-top: 0px !important;
    padding-left: 51px;
   }
  .item-list {
    max-height: unset;
  }
  .brands {
    display: none;
  }
  .slider {
    text-align: center;
  }
}
@media screen and (max-width: 475px) {
  .extended {
    width: 92vw;
    overflow-y:scroll;

  }
}
.page-router-component {
  margin-top: 10px;
  display: inline-block;
  width: 73%;
  vertical-align: top;
}
.page-router-component.container {
  width: 100%;
}
.mainframe {
  display: flex;
  margin-bottom: 20px;
  padding-left: 0px;
}
</style>